
const KPIStatData = () => {

    var exportVar = []

    var date = new Date();
    var now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
        date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());



    exportVar.push(
        {
            Title: "Toneladas/Hora",
            Value: (100 * Math.random()).toFixed(2),
            TargetValue: "PRODUCCION GLOBAL",
            IconName: "caret-up",
            IconRoot: "building",
            IconColor: "yellow",
            imageUrl: ""
        }
    )




    return exportVar
}



export default KPIStatData




